import {
  AttachmentRounded,
  ContactMailRounded,
  GroupRounded,
  InfoRounded,
  ManageAccounts,
} from "@mui/icons-material";
import { SxProps } from "@mui/material";
import { AccordionGroup } from "../../../App/Components/AccordionGroup/AccordionGroup";
import { IAccordion } from "../../../App/Typings/Accordions";
import { FileUploads } from "./Subcomponents/FileUploads";
import ProfileGroupInfo from "./Subcomponents/ProfileGroupInfo";
import { CandidateDetails } from "./Subcomponents/CandidateDetails";
import { ContactInformation } from "./Subcomponents/ContactInformation";
import CustomData from "./Subcomponents/CustomData";

const defaultAccordions: { [key: string]: IAccordion } = {
  contactInfoAccordion: {
    label: "Contact Information",
    AccordionChild: ContactInformation,
    icon: ContactMailRounded,
  },
  candidateDetailsAccordion: {
    label: "Candidate Details",
    AccordionChild: CandidateDetails,
    icon: InfoRounded,
  },
  groupMembershipsAccordion: {
    label: "Group Memberships",
    AccordionChild: ProfileGroupInfo,
    icon: GroupRounded,
  },
  attachmentsAccordion: {
    label: "Attachments",
    AccordionChild: FileUploads,
    icon: AttachmentRounded,
  },
  candidateFieldData: {
    label: "Custom Data",
    AccordionChild: CustomData,
    icon: ManageAccounts,
  },
};

export function CandidateAccordions({ sx }: { sx?: SxProps }) {
  return (
    <AccordionGroup
      sx={sx}
      config={{
        accordionGroupLabel: "Candidate Details",
        accordionA11yId: "candidate-accordions",
        accordions: Object.values(defaultAccordions),
      }}
    />
  );
}

export const sxSection = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "10px 15px",
  "&:not(:last-of-type)": {
    borderBottom: "1px solid rgba(0,0,0,0.1)",
  },
  "& a": {
    color: "text.primary",
  },
} as const;

export const sxHeading = { color: "text.secondary", fontWeight: 600 } as const;

export const sxBody = {
  color: "text.primary",
  fontWeight: 400,
  "& a:hover": { textDecoration: "underline" },
} as const;
